import "core-js/modules/es.array.filter";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../../../button/Button';
import NavigationContext from '../../../../navigation-context/NavigationContext';
import WellsFargoLogoIcon from '../../icons/logos/mass-market/WellsFargoLogoIcon';
import styles from './WellsFargoLogo.less';

var WellsFargoLogo = function WellsFargoLogo() {
  var dispatch = useDispatch();

  var _useContext = useContext(NavigationContext),
      getContainer = _useContext.getContainer,
      navigate = _useContext.navigate;

  var links = getContainer('MASTHEAD_NAV').sections[0].links;
  var link = links.filter(function (link) {
    return link.navigationId === 'WF_LOGO';
  })[0];

  var onClick = function onClick() {
    return navigate({
      dispatch: dispatch,
      link: link
    });
  };

  return /*#__PURE__*/React.createElement(Button, {
    role: "link",
    className: styles.button,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "visuallyHidden"
  }, "WELLS FARGO"), /*#__PURE__*/React.createElement(WellsFargoLogoIcon, null));
};

export default WellsFargoLogo;